import React from 'react'
import {
    AspectRatio,
    Box,
    HStack,
    Flex,
    Img,
    Text,
    Button,
    useMultiStyleConfig,
    Portal,
} from '@chakra-ui/react'
import {Link as ReactRouterLink} from 'react-router-dom'
import PropTypes from 'prop-types'
import {getDamImageUrl, getGlobalLink} from '../../../utils/contentstack-utils'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import {useHeaderRef} from '../../_app'

const PlpStickyBar = ({data}) => {
    const headerRef = useHeaderRef()
    const styles = useMultiStyleConfig('StickyMenu', {variant: 'plpSticky'})
    const categoryData = useGetCategoriesData()
    const {label, url, isAbsolute} = getGlobalLink(data?.cta, categoryData)
    const plpStickyBarTitle = data?.editorial_title
    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: ReactRouterLink,
              to: url,
          }

    const imageUrls = [
        getDamImageUrl(data?.image_1),
        getDamImageUrl(data?.image_2),
        getDamImageUrl(data?.image_3),
    ]

    return (
        <Portal containerRef={headerRef}>
            <Box data-testid="sticky-menu" {...styles.stickyBar}>
                <Flex layerStyle="full-width" {...styles.stickyBarContent}>
                    <HStack {...styles.imageContainer}>
                        {imageUrls.map((url, index) =>
                            url ? (
                                <AspectRatio key={index} ratio={75 / 85} {...styles.productImage}>
                                    <Img src={url} />
                                </AspectRatio>
                            ) : null,
                        )}
                    </HStack>
                    <Text {...styles.productText}>{plpStickyBarTitle}</Text>
                    {label && url && (
                        <Box {...styles.buttonContainer}>
                            <Button
                                w={'full'}
                                variant="primary"
                                {...buttonProps}
                                {...styles.buttonLabel}
                            >
                                {label}
                            </Button>
                        </Box>
                    )}
                </Flex>
            </Box>
        </Portal>
    )
}

PlpStickyBar.propTypes = {
    data: PropTypes.object,
}

export default PlpStickyBar
